// extracted by mini-css-extract-plugin
export var addToCartButton = "_sz-b";
export var arrowButtonContainer = "_sz-9";
export var arrowButtonIcon = "_sz-a";
export var carouselArrowButton = "_sz-6";
export var carouselElementContainer = "_sz-1";
export var left = "_sz-7";
export var productDisplayCarouselContainer = "_sz-0";
export var productTileContainer = "_sz-2";
export var productTileImage = "_sz-4";
export var productTileImageContainer = "_sz-3";
export var productTileTitle = "_sz-5";
export var right = "_sz-8";
export var sliderOverflow = "_sz-c";